<template>
  <div class="food-window-component">
    <v-row>
      <v-col sm="8">
        <span class="window-title font-weight-medium">
          {{ item.name }}
        </span>
      </v-col>
      <v-col sm="4">
        <v-btn
          @click="close"
          class="button button-back font-weight-medium"
          width="100%"
          color="#F1F3F6"
        >
          <font-awesome-icon icon="chevron-left" />
          Вернуться назад
        </v-btn>
      </v-col>
    </v-row>

    <div class="food-info-section d-flex justify-space-between">
      <div class="food-image d-flex align-center justify-center">
        <div class="badge-left d-flex flex-column align-center">
          <component :is="getLeftSticker" />
        </div>

        <div class="badge-right d-flex flex-column align-center">
          <component :is="getRightSticker" />
        </div>
        <img v-if="item.imageOriginal" :src="item.imageOriginal" :alt="item.name" />
        <font-awesome-icon
          v-if="!item.image"
          icon="utensils"
          class="no-image"
        />
      </div>

      <div class="food-info">
        <span class="label">Состав:</span>
        <span class="composition">{{ item.composition }}</span>
        <div class="food-characteristics d-flex a-center">
          <div class="characteristic">
            <span class="label">Вес:</span>
            <span class="unit font-weight-medium">
              <font-awesome-icon icon="weight-hanging" />
              {{ getWeight }}
            </span>
          </div>
          <div class="characteristic">
            <span class="label">Калорийность</span>
            <span class="unit font-weight-medium">{{ getCalories }}</span>
          </div>
          <div class="characteristic">
            <span class="label">Белки</span>
            <span class="unit font-weight-medium">{{ getProteins }}</span>
          </div>
          <div class="characteristic">
            <span class="label">Жиры</span>
            <span class="unit font-weight-medium">{{ getFats }}</span>
          </div>
          <div class="characteristic">
            <span class="label">Углеводы</span>
            <span class="unit font-weight-medium">{{ getCarbohydrates }}</span>
          </div>
        </div>

        <div class="food-price">
          <v-row class="d-flex align-end">
            <v-col sm="6">
              <span class="price-label">Стоимость товара:</span>
              <span class="price font-weight-medium">{{ getItemPrice }} ₽</span>
            </v-col>
            <v-col sm="6">
              <div class="d-flex bonus-label" v-if="foxCoinsAdd">
                <icon-bonus />
                <div>
                  <span class="bonus-label">Будет начисленно бонусов:</span>
                  <span class="bonus font-weight-medium">+{{ foxCoinsAdd }} ₽</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <div class="button-group">
          <v-row>
            <v-col sm="6">
              <v-btn
                v-if="item.modifications && item.modifications.length"
                @click="addModification"
                :loading="isAddModLoading"
                class="button button-half font-weight-medium"
                block
                depressed
              >
                <span class="icon">+M</span>
                {{ getModificationName }}
                <span class="price">{{ getModificationPrice }}</span>
              </v-btn>
            </v-col>
            <v-col sm="6">
              <v-btn
                @click="addItem"
                :loading="isAddItemLoading"
                class="button button-add font-weight-medium"
                dark
                block
                depressed
              >
                <span
                  class="button-add-title d-flex align-center justify-space-between"
                >
                  <font-awesome-icon icon="plus" />
                  <span>Добавить в заказ</span>
                  <span class="price">{{ getItemPrice }} ₽</span>
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <div class="description-section">
      <span class="label">Описание:</span>
      <span class="description">{{ item.description }}</span>
    </div>

    <div class="similar-food-section">
      <span class="label">Похожие блюда</span>
      <v-row>
        <v-col
          v-for="(similarItem, i) in similarItems.slice(0, 4)"
          :key="i"
          sm="3"
        >
          <food-card :item="similarItem" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import FoodCard from '../food-card/FoodCard'
  import mixinGetFoodStickers from '@/mixins/get-food-stickers'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import IconBonus from '@/components/icons/IconBonus'

  export default {
    name: 'FoodWindowOld',
    mixins: [mixinGetFoodStickers, mixinSnackbarMessage],
    components: {
      FoodCard,
      IconBonus,
    },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        similarItems: [],
        isAddItemLoading: false,
        isAddModLoading: false,
      }
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
        menuItems: (state) => state.newOrder.menuItemsList,
      }),
      getModificationName () {
        return this.item.modifications[0].modification
          ? this.item.modifications[0].modification.name
          : '–'
      },
      getModificationPrice () {
        return this.item.modifications[0].modification &&
          this.item.modifications[0].modification.priceAdd
          ? this.item.modifications[0].modification.priceAdd + ' ₽'
          : '–'
      },
      getItemPrice () {
        return this.item.price ? this.item.price : ''
      },
      getCalories () {
        return this.item.technicalCard
          ? this.item.technicalCard.calories + ' кКал'
          : '–'
      },
      getCarbohydrates () {
        return this.item.technicalCard
          ? this.item.technicalCard.carbohydrates + ' г'
          : '–'
      },
      getWeight () {
        return this.item.technicalCard
          ? this.item.technicalCard.weight + ' г'
          : '–'
      },
      getFats () {
        return this.item.technicalCard ? this.item.technicalCard.fats + ' г' : '–'
      },
      getProteins () {
        return this.item.technicalCard
          ? this.item.technicalCard.proteins + ' г'
          : '–'
      },
      foxCoinsAdd () {
        return this.item.foxCoinsAdd
      },
    },
    methods: {
      addModification () {
        this.isAddModLoading = true
        const payload = {
          modificationId: this.item.modifications[0].id,
          menuItemId: this.item.id,
        }
        this.$store
          .dispatch('baskets/addBasketItem', {
            data: payload,
            id: this.basket.id,
          })
          .then((res) => {
            this.isAddModLoading = false
            if (res.status === 200) {
              this.showSuccessMessage('Добавлено в корзину')
              this.$store.commit('baskets/setBasket', res.data.data)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      addItem () {
        this.isAddItemLoading = true
        const payload = {
          menuItemId: this.item.id,
        }
        this.$store
          .dispatch('baskets/addBasketItem', {
            data: payload,
            id: this.basket.id,
          })
          .then((res) => {
            this.isAddItemLoading = false
            if (res.status === 200) {
              this.showSuccessMessage('Добавлено в корзину')
              this.$store.commit('baskets/setBasket', res.data.data)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      close () {
        this.$emit('close')
      },
    },
    mounted () {
      this.similarItems = this.menuItems
    },
  }
</script>

<style lang="less" scoped>
.food-window-component {
  .window-title {
    font-size: 34px;
    line-height: 1;
  }

  .button-back {
    height: 80px;
    font-size: 15px;
    box-shadow: 0 3px 6px #00000029 !important;

    svg {
      margin-right: 8px;
    }

    svg {
      .fill-svg(#0033ff);
    }
  }

  .food-info-section {
    margin-bottom: 36px;

    .food-image {
      position: relative;
      background-color: #f6f6f6;
      border-radius: 30px;
      max-width: 432px;
      width: 100%;
      padding: 80px 46px 69px 46px;
      margin-right: 25px;
      z-index: 0;
      svg.no-image {
        width: 70px;
        height: 70px;
        opacity: 0.4;
        .fill-svg(@color-primary);
      }

      .badge-left {
        position: absolute;
        top: 21px;
        left: 24px;
        z-index: 1;
      }

      .badge-right {
        position: absolute;
        top: 21px;
        right: 24px;
        z-index: 1;
      }

      img {
        max-height: 242px;
        height: 100%;
      }
    }

    .food-info {
      flex: 1;

      .label {
        display: block;
        margin-bottom: 9px;
        font-size: 1.42em;
        line-height: 1;
      }

      .composition {
        display: block;
        margin-bottom: 22px;
        font-size: 1.14em;
        line-height: 1.3;
      }

      .food-characteristics {
        .characteristic {
          padding: 11px 18px 16px 18px;
          border-radius: 15px;
          background-color: @color-secondary;
          margin-right: 10px;
          text-align: center;
          margin-bottom: 21px;

          &:last-child {
            margin-right: 0;
          }

          .label {
            font-size: 16px;
            margin-bottom: 10px;
          }

          .unit {
            font-size: 16px;
            line-height: 1;
          }
        }
      }

      .food-price {
        margin-bottom: 28px;

        .price-label {
          display: block;
          font-size: 24px;
          line-height: 21px;
        }

        .price {
          font-size: 50px;
          line-height: 60px;
        }

        .bonus-label {
          display: block;
          font-size: 16px;
          line-height: 21px;
        }

        .bonus {
          display: block;
          font-size: 21px;
          line-height: 25px;
          margin-bottom: 10px;
        }
      }

      .button-group {
        .button {
          height: 80px;
          font-size: 15px;
          line-height: 20px;
          border-radius: 10px;

          &.button-half {
            background-color: @color-secondary;

            .icon {
              display: inline-block;
              padding: 6px 5px;
              margin-right: 12px;
              border-radius: 6px;
              background-color: @color-primary;
              color: #ffffff;
            }

            .price {
              display: inline-block;
              margin-left: 19px;
            }
          }

          &.button-add {
            background-color: @color-primary;

            .button-add-title {
              svg {
                width: 19px;
                height: 19px;
                margin-right: 22px;
              }

              .price {
                margin-left: 25px;
              }
            }
          }
        }
      }
    }
  }

  .description-section {
    margin-bottom: 25px;
    .label {
      display: block;
      font-size: 24px;
      line-height: 21px;
      margin-bottom: 14px;
    }
    .description {
      display: block;
      font-size: 16px;
      line-height: 21px;
    }
  }

  .similar-food-section {
    margin-bottom: 30px;
    .label {
      display: block;
      font-size: 24px;
      line-height: 21px;
    }
  }
}
</style>
